import React, { Component } from 'react';
import { Divider, Paper, Grid, Container, Typography, Button, Hidden, IconButton, FormControl } from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons'
import { CSSProperties } from '@material-ui/styles';
import { withRouter, RouteComponentProps } from 'react-router';
import ProductsListOrder from './ProductList/ProductsListOrder';
import { OrderSheetData, OrderSheetItemData } from '../../api/models/OrderSheetData';
import { CreateOrderModel } from '../../api/models/OrderData';
import { toOrderItems } from '../selectors';
import * as moment from 'moment';
import DeliveryDeadline from './DeliveryDeadline';

type Props = {
    updateOrderSheetBusy: boolean,
    orderSheet: OrderSheetData,
    expandByDefault: boolean,
    onExpand: (expanded: boolean) => void,
    onOrderItemRemove: (prod: OrderSheetItemData) => void,
    onOrderItemQuantityChange: (prod: OrderSheetItemData) => void,
    onOrderSheetRename: (orderSheet: OrderSheetData) => void,
    updateOrderSheet: (orderSheet: OrderSheetData) => void,
    createOrderAndQuoteIt: (orderData: CreateOrderModel) => void
} & RouteComponentProps<any>

type State = {
    expanded: boolean,
    deliveryTimeFrom: string | null,
    deliveryTimeTo: string | null
}

class OrderSheetPopper extends Component<Props, State> {
    constructor(props: Props) {
        super(props)

        this.state = {
            expanded: this.props.expandByDefault,
            deliveryTimeFrom: null,
            deliveryTimeTo: null,
        }

        this.togglePopper = this.togglePopper.bind(this)
        this.renameOrderSheet = this.renameOrderSheet.bind(this)
        this.onQuoteClick = this.onQuoteClick.bind(this)
    }

    togglePopper() {
        let expanded = !this.state.expanded
        this.setState({ expanded })
        this.props.onExpand(expanded)
    }

    onQuoteClick() {
        this.props.createOrderAndQuoteIt({ items: toOrderItems(this.props.orderSheet), orderSheetId: this.props.orderSheet.id, deliveryTimeFrom: this.state.deliveryTimeFrom, deliveryTimeTo: this.state.deliveryTimeTo })
        this.props.history.push('/Order')
    }

    renderQuoteButton() {
        let numbOfOrderedItems = this.props.orderSheet.items.length === 0 ? 0 : this.props.orderSheet.items.filter(i => i.quantity !== null && i.quantity > 0).length
        return (<Button disabled={numbOfOrderedItems === 0} onClick={this.onQuoteClick} style={{ width: '80%' }} color="secondary" variant='contained'>Quote&nbsp;&nbsp;{numbOfOrderedItems}&nbsp;&nbsp;product{numbOfOrderedItems > 1 ? "s" : ""}</Button>)
    }

    renameOrderSheet(name: string) {
        this.props.onOrderSheetRename({ ... this.props.orderSheet, name })
    }

    render() {
        let style: CSSProperties = {
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            minHeight: '100px',
            height: '100%',
            maxHeight: (this.state.expanded ? '100%' : '10vh'),
        }

        return (
            <section>
                <div className="order-transition" style={style}>
                    <Paper style={{ height: '100%', boxShadow: '0px 0px 5px 1px #888888', padding: "5px 10px 0px 10px", overflow: 'auto' }} >
                        <Container maxWidth="md" onClick={this.togglePopper} style={{ cursor: 'pointer' }} >
                            <Grid container alignItems="center" alignContent="center">
                                <Grid item xs={2} sm={1}>
                                    <IconButton onClick={() => { this.props.history.push("/") }}>
                                        <ArrowBack />
                                    </IconButton>
                                </Grid>
                                <Grid item xs={7} sm={6}>

                                    <Typography variant="h2">{this.props.orderSheet.name}</Typography>
                                </Grid>
                                <Grid style={{ textAlign: 'right' }} item xs={3} sm={5}>
                                    {this.state.expanded &&
                                        <Button variant="outlined" color="primary" >Add <Hidden only="xs">products</Hidden></Button>
                                    }
                                </Grid>
                            </Grid>

                            <Grid container alignItems="center">
                                <Grid item xs={2} sm={1}></Grid>
                                <Grid item sm={3}>
                                    <Typography variant="subtitle1">{this.props.orderSheet.items.length} ITEMS</Typography>
                                </Grid>

                                <Hidden only="xs">
                                    {this.state.expanded === false &&
                                        <Grid item xs={12} sm={4} style={{ textAlign: 'center' }} >
                                            <Button onClick={this.togglePopper} disabled={this.props.orderSheet.items.length === 0} style={{ width: '80%' }} color="primary" variant='contained'>Set quantities</Button>
                                        </Grid>
                                    }
                                </Hidden>
                            </Grid>
                        </Container>

                        {this.state.expanded === true &&
                            <Container maxWidth="md">
                                <Grid container alignItems="center" style={{ paddingBottom: "15px" }}>
                                    <Grid item xs={12} sm={12}>
                                        <Divider></Divider>
                                        <ProductsListOrder
                                            updateOrderSheetBusy={this.props.updateOrderSheetBusy}
                                            orderProducts={this.props.orderSheet.items}
                                            onProductQuantityChange={this.props.onOrderItemQuantityChange}
                                            onProductRemove={this.props.onOrderItemRemove}>
                                        </ProductsListOrder>
                                    </Grid>

                                    <DeliveryDeadline
                                        deliveryTimeFrom={this.state.deliveryTimeFrom}
                                        deliveryTimeTo={this.state.deliveryTimeTo}
                                        onChange={(deliveryTimeFrom: string | null, deliveryTimeTo: string | null) => { this.setState({ deliveryTimeFrom, deliveryTimeTo }) }}
                                    />

                                    <Grid item sm={4}>
                                    </Grid>
                                    <Grid style={{ textAlign: 'center' }} item sm={4} xs={12}>
                                        {this.renderQuoteButton()}
                                    </Grid>
                                </Grid>
                            </Container>
                        }
                    </Paper>
                </div>
            </section >
        );
    }
}

export default withRouter(OrderSheetPopper);